// extracted by mini-css-extract-plugin
export default {"container":"AddToCart_container__NDl-O","amount":"AddToCart_amount__XkA7c","add-to-cart":"AddToCart_add-to-cart__bOQ2g","sr-only":"AddToCart_sr-only__n-mZZ"};